module.exports = __webpack_public_path__ + "static/img/Q.59564bc.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/ssxxg/Q.png
// module id = eVYX
// module chunks = 0